import { FC, Fragment, useEffect, useState } from 'react';
import { IOTP } from '@/components/OTP/types';
import {
  Box,
  ContentStyled,
  ErrorMessage,
  ImageBox,
  SecondBox,
  TextContainer,
  SecondContent,
  SecondTitle,
  Title,
  ChangePhoneNumber,
  VodafoneTitle,
  FlexBoxOTP,
  IslemYapilanNumaraTitle,
  IslemYapilanNumara,
  NotificationBoxAlert,
  SMSTitle,
} from '@/components/OTP/styled';
import Input from '@/components/Input';
import {
  formatPhone,
  getSessionStorage,
  imageLoader,
  setSessionStorage,
} from '@/utils';
import {
  addErrorMessage,
  clearAllState,
  clearErrorMessage,
  setPhone,
  setTbgClusterId,
} from '@/redux/appSlice';
import Button from '@/components/Button';
import Image from 'next/legacy/image';
import { Mail, Tel, WhiteAlert } from '@/icons';
import {
  createNVFSession,
  createVFSession,
  sendNVFOTP,
  sendVFOTP,
} from '@/services/session-service';
import { useAppSelector } from '@/redux/hooks';
import useWindowSize from '@/hooks/useWindowSize';
import OTPCountDown from '@/components/OTPCountDown';
import { reportOtpError, reportOtpPageView } from '@/utils/reporter';
import { useRouter } from 'next/router';
import {
  getApplicationAddress,
  getDataInsights,
  insertFixedApplication,
} from '@/services/fixed-services';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import Text from '@/common/Text/Text';
import { autoLoginImg } from '@/icons';
import {
  DegistirButtonWrapper,
  OtpInput,
  OtpWrapper,
} from '../OtpInput/styled';
import Informing from '../AdvantageOfVf/Informing/Informing';

const OTP: FC<IOTP> = ({ AutoLogin, setAutoLogin, isLinkat }) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const router = useRouter();
  const time = 180;
  const { sid, isError, errorMessage, loading, phone, tbgClusterId } =
    useAppSelector((state) => state.app);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [timeLeft, setTimeLeft] = useState<number>(time);
  const size: {
    width: number | undefined;
    height: number | undefined;
  } = useWindowSize();
  const [otp, setOtp] = useState<string[]>(['', '', '', '']);
  const [otpValidCode, setOtpValidCode] = useState<any>();
  const [otpImageURL, setOtpImageURL] = useState('');

  useEffect(() => {
    window['setOtpImage'] = (otpImgSrc: string) => {
      setOtpImageURL(otpImgSrc);
    };
  });

  useEffect(() => {
    scrollTo(0, 0);
  }, [sid]);

  useEffect(() => {
    sessionStorage.removeItem('success');
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      setOtp(['', '', '', '']);
    }
  }, [timeLeft]);

  const handlePhone = (e: any) => {
    dispatch(setPhone(formatPhone(e?.target?.value)));
    const phoneRegex = e?.target?.value?.replace(/[^\d]/g, '');
    if (phoneRegex?.length > 0 && !phoneRegex?.startsWith('5')) {
      setIsValid(true);
      dispatch(addErrorMessage('Hatalı numara girdiniz, tekrar deneyiniz.'));
    } else {
      setIsValid(false);
      dispatch(clearErrorMessage());
    }
  };

  const changeNumber = () => {
    setAutoLogin(false);
    setTimeLeft(time);
    setOtp(['', '', '', '']);
    dispatch(clearAllState());
  };

  const handleOTP = async () => {
    setTimeLeft(time);
    reportOtpPageView();
    dispatch(sendNVFOTP(phone)).then((res) => {
      const payload = res.payload;
      if (
        payload &&
        payload.result &&
        payload.result.result === 'FAIL' &&
        payload.result.resultCode === 'S9703100000'
      ) {
        dispatch(sendVFOTP(phone)).then((response) => {
          if (
            response &&
            response.payload &&
            response.payload.result &&
            response.payload.result.result === 'FAIL'
          ) {
            reportOtpError(
              response.payload.result?.resultCode,
              response.payload.result?.resultDesc,
              'sendSessionOtp'
            );
          }
        });
      } else if (
        payload &&
        payload.result &&
        payload.result.result === 'FAIL' &&
        payload.result.resultCode !== 'S9703100000'
      ) {
        reportOtpError(
          payload?.result?.resultCode,
          payload?.result?.resultDesc,
          'createNvfSession'
        );
      }
    });
  };

  const handleReSend = () => {
    dispatch(clearErrorMessage());
    if (sid.includes('NVF') === true) {
      dispatch(sendNVFOTP(phone));
    } else {
      dispatch(sendVFOTP(phone));
    }
  };

  const handleCreateSession = () => {
    if (sid.includes('OTP')) {
      dispatch(createVFSession({ otp: otpValidCode, sid })).then((res) => {
        if (
          res.payload &&
          res.payload.result &&
          res.payload.result.result === 'SUCCESS'
        ) {
          handleFixedApplication();
        } else if (
          res.payload &&
          res.payload.result &&
          res.payload.result.result === 'FAIL'
        ) {
          reportOtpError(
            res?.payload?.result?.resultCode,
            res?.payload?.result?.resultDesc,
            'createSession'
          );
        }
      });
    } else {
      dispatch(createNVFSession({ otp: otpValidCode, sid })).then((res) => {
        if (
          res.payload &&
          res.payload.result &&
          res.payload.result.result === 'SUCCESS'
        ) {
          handleFixedApplication();
        } else if (
          res.payload &&
          res.payload.result &&
          res.payload.result.result === 'FAIL'
        ) {
          reportOtpError(
            res?.payload?.result?.resultCode,
            res?.payload?.result?.resultDesc,
            'createNvfSession'
          );
        }
      });
    }
  };

  const handleInputChange = (index: number, value: string) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };
  const handleBackspace = (index: number) => {
    if (otp[index] === '' && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      prevInput?.focus();
    }
  };

  useEffect(() => {
    if (!otp?.includes('')) {
      setOtpValidCode(otp?.join(''));
    }
  }, [otp, otpValidCode]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleAutoLogin = () => {
    try {
      dispatch(
        insertFixedApplication({
          sid: sid,
          formName: 'FULL_FORM_AUTO_LOGIN',
        })
      ).then((res) => {
        if (
          res.payload &&
          res.payload.result &&
          res.payload.result.result === 'SUCCESS'
        ) {
          dispatch(
            getDataInsights({
              sid: res?.payload?.result?.session?.sessionId,
              appId: res?.payload?.applicationId,
            })
          ).then(() => {
            dispatch(getApplicationAddress(sid)).then((response) => {
              if (
                response.payload &&
                response.payload.result &&
                response.payload.result.result === 'SUCCESS'
              ) {
                const storedData = getSessionStorage('userData');
                storedData.formName = 'FULL_FORM_AUTO_LOGIN';
                setSessionStorage('userData', storedData);
                router.push(`/home/address`);
              }
            });
          });
        }
      });
    } catch (error) {
      console.log(error);
      router.push('/home');
    }
  };

  const handleFixedApplication = () => {
    const storedData = getSessionStorage('userData');
    dispatch(insertFixedApplication({ sid: sid, formName: 'Full Form' })).then(
      (res) => {
        if (
          res.payload &&
          res.payload.result &&
          res.payload.result.result === 'SUCCESS'
        ) {
          dispatch(
            getDataInsights({ ...storedData, appId: res.payload.applicationId })
          )
            .then((responseFbData) => {})
            .then(() => {
              dispatch(getApplicationAddress(sid)).then((response) => {
                if (
                  response.payload &&
                  response.payload.result &&
                  response.payload.result.result === 'SUCCESS'
                ) {
                  router.push('/home/address');
                }
              });
            });
        }
      }
    );
  };

  return (
    <Fragment>
      {sid && !AutoLogin ? (
        <Fragment>
          <SMSTitle>
            Telefonunuza gelen 4 haneli tek kullanımlık şifreyi aşağıdaki alana
            giriniz.
          </SMSTitle>
          <FlexBoxOTP isPwPage={timeLeft}>
            <SecondContent>
              <SecondBox isError={isError}>
                <SecondTitle>
                  {size && size.width && size.width <= 768 ? (
                    <Fragment>
                      <Fragment>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div
                            style={{ display: 'flex', flexDirection: 'row' }}
                          >
                            <Image
                              src={Tel}
                              alt="Vodafone Ev İnterneti"
                              width={32}
                              height={32}
                              loader={imageLoader}
                            />
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                marginLeft: '8px',
                              }}
                            >
                              <IslemYapilanNumaraTitle>
                                {size && size.width && size.width <= 768
                                  ? 'İletişim numarası '
                                  : 'İşlem yapılan numara'}
                              </IslemYapilanNumaraTitle>
                              <IslemYapilanNumara>
                                {formatPhone(phone)}
                              </IslemYapilanNumara>
                            </div>
                          </div>{' '}
                          <DegistirButtonWrapper>
                            <Button onClick={() => changeNumber()}>
                              Değiştir
                            </Button>{' '}
                          </DegistirButtonWrapper>
                        </div>
                      </Fragment>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <Image
                            src={Tel}
                            alt="Vodafone Ev İnterneti"
                            width={32}
                            height={32}
                            loader={imageLoader}
                          />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              marginLeft: '8px',
                            }}
                          >
                            <IslemYapilanNumaraTitle>
                              {size && size.width && size.width >= 768
                                ? 'İşlem yapılan numara'
                                : 'İletişim numarası'}
                            </IslemYapilanNumaraTitle>
                            <IslemYapilanNumara>
                              {formatPhone(phone)}
                            </IslemYapilanNumara>
                          </div>
                        </div>
                        <DegistirButtonWrapper>
                          <Button onClick={() => changeNumber()}>
                            Değiştir
                          </Button>{' '}
                        </DegistirButtonWrapper>
                      </div>
                    </Fragment>
                  )}
                </SecondTitle>

                <Fragment>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Image
                      src={Mail}
                      alt="Vodafone Ev İnterneti"
                      width={32}
                      height={32}
                      loader={imageLoader}
                    />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginLeft: '8px',
                        color: '#333333',
                      }}
                    >
                      <IslemYapilanNumaraTitle>
                        SMS Onayı
                      </IslemYapilanNumaraTitle>
                    </div>
                  </div>{' '}
                  {isError && timeLeft !== 0 && (
                    <Fragment>
                      <NotificationBoxAlert>
                        <div className="icon">
                          <Image
                            src={WhiteAlert}
                            loader={imageLoader}
                            alt=""
                            objectFit="contain"
                            width={24}
                            height={24}
                          />
                        </div>
                        <div className="text">{errorMessage}</div>
                      </NotificationBoxAlert>{' '}
                    </Fragment>
                  )}{' '}
                  {timeLeft == 0 && (
                    <NotificationBoxAlert>
                      <div className="icon">
                        <Image
                          src={WhiteAlert}
                          loader={imageLoader}
                          alt=""
                          objectFit="contain"
                          width={24}
                          height={24}
                        />
                      </div>
                      <div className="text">
                        {
                          'Belirtilen sürede şifreyi girmediniz. Lütfen butona tıklayarak yeni şifre alınız.'
                        }
                      </div>
                    </NotificationBoxAlert>
                  )}
                  <OtpWrapper>
                    {otp?.map((digit, index) => (
                      <OtpInput
                        key={index}
                        id={`otp-${index}`}
                        type="text"
                        maxLength={1} // Her kutuya yalnızca bir karakter
                        value={digit}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            // Sadece sayılar
                            handleInputChange(index, value);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Backspace') {
                            handleBackspace(index);
                          }
                          if (
                            e.key === 'Enter' &&
                            otp.every((digit) => digit !== '')
                          ) {
                            handleCreateSession(); // Enter’a basıldığında butonun işlevi tetiklenir
                          }
                        }}
                      />
                    ))}
                  </OtpWrapper>
                  <OTPCountDown
                    time={time}
                    timeLeft={timeLeft}
                    setTimeLeft={setTimeLeft}
                    onClick={() => handleReSend()}
                  />
                </Fragment>
                <Button
                  disabled={otp?.includes('') || !timeLeft || loading}
                  style={{ marginTop: timeLeft === 0 && isError ? '18px' : '' }}
                  onClick={() => !loading && handleCreateSession()}
                >
                  Onayla ve devam et
                </Button>
              </SecondBox>
            </SecondContent>
          </FlexBoxOTP>
        </Fragment>
      ) : AutoLogin ? (
        <ContentStyled>
          <Box isError={isError}>
            {size && size.width && size.width <= 768 ? (
              <VodafoneTitle>
                Vodafone Ev İnterneti dünyasına hoşgeldiniz!
              </VodafoneTitle>
            ) : (
              <VodafoneTitle>Ev İnterneti dünyasına hoşgeldiniz!</VodafoneTitle>
            )}
            <Title>
              Tüm kanallarda geçerli altyapınıza en uygun tek tarifeyi size
              sunabilmemiz ve sizinle iletişime geçebilmemiz için lütfen
              iletişim numaranızı giriniz.
            </Title>
            {isLinkat && (
              <Title>
                Link At Kampanyası&apos;ndan faydalanmak için &quot;Tarife
                Seçimi&quot; adımında kupon kodunuzu girebilirsiniz.
              </Title>
            )}

            <TextContainer>
              <Text fontFamily="Bold" fontSize={18}>
                {' '}
                İletişim Numaranız
              </Text>
              <ChangePhoneNumber>
                <Text
                  fontFamily="Bold"
                  fontSize={18}
                  margin={'12px 12px 0px 0px'}
                >
                  {formatPhone(phone)}
                </Text>
                <Text
                  fontFamily="Bold"
                  fontSize={18}
                  color="red"
                  margin={'12px 0px 0px 0px'}
                  onClick={() => changeNumber()}
                >
                  Numarayı değiştir
                </Text>
              </ChangePhoneNumber>
            </TextContainer>
            <Button onClick={() => handleAutoLogin()}>
              Bu numara ile devam et
            </Button>
          </Box>
          <ImageBox>
            <Image
              id="otp-home-image"
              src={otpImageURL || autoLoginImg}
              alt="Vodafone Ev İnterneti"
              layout="fill"
              loader={imageLoader}
            />
          </ImageBox>
        </ContentStyled>
      ) : (
        <ContentStyled>
          <Box isError={isError}>
            {size && size.width && size.width >= 768 ? (
              <VodafoneTitle>
                Vodafone Ev İnterneti dünyasına hoşgeldiniz!
              </VodafoneTitle>
            ) : (
              <VodafoneTitle>Ev İnterneti dünyasına hoşgeldiniz!</VodafoneTitle>
            )}
            <Title>
              Tüm kanallarda geçerli altyapınıza en uygun tek tarifeyi size
              sunabilmemiz ve sizinle iletişime geçebilmemiz için lütfen
              iletişim numaranızı giriniz.
            </Title>
            {isLinkat && (
              <Title>
                Link At Kampanyası&apos;ndan faydalanmak için &quot;Tarife
                Seçimi&quot; adımında kupon kodunuzu girebilirsiniz.
              </Title>
            )}
            <Input
              label="İletişim numaranız"
              onChange={(e: any) => handlePhone(e)}
              value={formatPhone(phone)}
              maxLength={15}
              pattern="[0-9]*"
              deleteButton
              error={isValid}
              placeholder="5XX XXX XX XX"
              autoFocus={true}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && (!isValid || phone?.length == 10)) {
                  handleOTP(); // Enter’a basıldığında butonun işlevi tetiklenir
                }
              }}
            />
            {isError && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <Button
              onClick={() => handleOTP()}
              disabled={isValid || phone?.length !== 10 || loading}
            >
              Devam et
            </Button>
            {/* <Informing /> */}
          </Box>
        </ContentStyled>
      )}
    </Fragment>
  );
};

export default OTP;
